import React from 'react';
import ContentLayout from '../core/ContentLayout';
import I18n from '../../blocks/localization';
import { PROMET_CONTACT_MAIL, PROMET_CONTACT_PHONE, PROMET_WEB } from '../../config';
import HorizontalDivider from '../shared/HorizontalDivider';

const Contact = () => {
    const getContactPhoneNumber = (): string => {
        return PROMET_CONTACT_PHONE.replace(' ', '');
    }

    return (
        <ContentLayout titleTranslateId='contact.title'>
            <p>{I18n.t('contact.infoText')}</p>

            <HorizontalDivider />

            <p>{I18n.t('contact.address')}: Promet d.o.o. Hercegovačka 20 Split, {I18n.t('croatia')}</p>
            <p>{I18n.t('contact.oib')}: 13421314997</p>
            <p>{I18n.t('contact.mb')}: 03129012</p>

            <HorizontalDivider />
            
            <p>{I18n.t('contact.freeInfoTelephone')}: <a href={`tel://:${getContactPhoneNumber()}`}>{PROMET_CONTACT_PHONE}</a></p>
            <p>{I18n.t('contact.webAddress')}: <a href={`https://${PROMET_WEB}`}>{PROMET_WEB}</a></p>
            <p>{I18n.t('contact.emailAddress')}: <a href={`mailto:${PROMET_CONTACT_MAIL}`}>{PROMET_CONTACT_MAIL}</a></p>
        </ContentLayout>
    );
}

export default Contact;
